import { Tooltip } from '@mui/material';
import { WorkflowLockStatus } from '../WorkflowEngine/types';

export default ({
  lockStatus,
  children
}: {
  lockStatus: WorkflowLockStatus;
  children: JSX.Element;
}) => {
  return (
    <Tooltip
      followCursor
      disableFocusListener
      title={
        lockStatus?.lockedDate
          ? `This workflow was locked by ${lockStatus?.lockedBy} on ${new Date(
              lockStatus?.lockedDate
            ).toDateString()} at ${new Date(
              lockStatus?.lockedDate
            ).toLocaleTimeString()}`
          : ''
      }
    >
      <span>{children}</span>
    </Tooltip>
  );
};
